import React from "react";
import MainHome from "../components/MainHome";

function Home() {
  return (
    <>
      <MainHome />
    </>
  );
}

export default Home;
